import { filterBy } from '@progress/kendo-data-query';
import {
  MultiSelect,
  MultiSelectChangeEvent,
  MultiSelectFilterChangeEvent,
} from '@progress/kendo-react-dropdowns';
import React, { useEffect, useId, useState } from 'react';
import { isFirefoxBrowser } from 'src/utils';

interface MultiSelectBoxProps {
  label?: string;
  data: any[];
  placeholder?: string | undefined;
  value: any[];
  setValue: (value: any[]) => void;
  width?: string;
  size?: 'small' | 'medium' | 'large';
  textField?: string;
  dataItemKey?: string;
  valid?: boolean;
}

const MultiSelectBox: React.FC<MultiSelectBoxProps> = ({
  label,
  data,
  placeholder,
  value,
  setValue,
  width,
  size,
  dataItemKey,
  textField,
  valid,
}) => {
  const id = useId();
  const [listData, setListData] = useState<any[]>((data || []).slice());
  const handleChange = (e: MultiSelectChangeEvent) => {
    const values = e.target.value;
    if (value?.length < values.length) {
      const el = document.querySelector(`.k-multiselect`);
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    }
    setValue(values);
  };
  const filterChange = (event: MultiSelectFilterChangeEvent) => {
    setListData(filterBy((data || []).slice(), event.filter));
  };
  useEffect(() => {
    if (data) {
      setListData((data || []).slice());
    }
  }, [data]);

  useEffect(() => {
    if (isFirefoxBrowser) {
      const body = document.querySelector('.k-clear-value') as HTMLElement | null;
      if (body) {
        body.style.setProperty('right', '14px', 'important');
      }
    }
  }, []);

  const listNoDataRender = (element: React.ReactElement<HTMLDivElement>) => {
    const noData = (
      <h4 style={{ fontSize: '1em' }}>
        <span className="k-icon k-i-warning" style={{ fontSize: '2.5em' }} />
        <br />
        <br />
        No matches found.
      </h4>
    );

    return React.cloneElement(element, { ...element.props }, noData);
  };

  useEffect(() => {
    const searchIcon = document.querySelector('.custom-multiselect .k-clear-value') as HTMLElement | null;
    if (searchIcon && searchIcon.removeAttribute) {
      searchIcon.removeAttribute('title');
      const clickHandler = (e: Event) => {
        e.stopPropagation();
        e.preventDefault();
      };
      searchIcon.addEventListener('click', clickHandler);
      return () => {
        searchIcon.removeEventListener('click', clickHandler);
      };
    }
  }, []);

  return (
    <div style={{ width }}>
      <MultiSelect
        size={size}
        label={label}
        value={value}
        data={listData}
        dataItemKey={dataItemKey}
        textField={textField}
        filterable={true}
        onFilterChange={filterChange}
        onChange={handleChange}
        placeholder={placeholder}
        listNoDataRender={listNoDataRender}
        autoClose={false}
        id={id}
        className={`max-h-[130px] !overflow-auto custom-multiselect`}
        valid={valid}
      />
    </div>
  );
};

export default MultiSelectBox;
